module.exports = __webpack_public_path__ + "static/img/img_ycs@2x.23c35b99.png";